export default __webpack_public_path__ + "static/media/CinzelRegular.df2966c1.ttf";